// ===========================  Modules =================================== //
export const automationModules = {
  EVENTS: 'EVENTS',
  TASKS: 'TASKS',
  BILLING: 'BILLING',
  CASES: 'CASES',
  FILES: 'FILES',
  CONTACTS: 'CONTACTS',
  LEADS: 'LEADS',
  MESSAGES: 'MESSAGES',
  FORMS: 'FORMS',
};

// ===========================  Triggers =================================== //
const eventTriggerAction = {
  label: 'Events',
  items: [
    { label: 'Event Created', code: 'TRIG_EVENT_CREATE', ruleValidationCode: 'EVENT_CREATE', module: automationModules.EVENTS },
    { label: 'Event Cancelled', code: 'TRIG_EVENT_CANCEL', ruleValidationCode: 'EVENT_CANCEL', module: automationModules.EVENTS },
    {
      label: 'Event Date Or Time Changed',
      code: 'TRIG_EVENT_DATE_TIME_CHANGED',
      ruleValidationCode: 'EVENT_DATE_TIME_CHANGED',
      module: automationModules.EVENTS,
    },
  ],
};

const taskTriggerAction = {
  label: 'Tasks',
  items: [
    { label: 'New Task Created', code: 'TRIG_TASK_CREATE', ruleValidationCode: 'TASK_CREATE', module: automationModules.TASKS },
    {
      label: 'Task Status Changed',
      code: 'TRIG_TASK_STATUS_CHANGE',
      ruleValidationCode: 'TASK_STATUS_CHANGE',
      module: automationModules.TASKS,
    },
  ],
};

const billingTriggerAction = {
  label: 'Billing',
  items: [
    {
      label: 'New Payment Received',
      code: 'TRIG_PAYMENT_RECEIVE',
      ruleValidationCode: 'PAYMENT_RECEIVE',
      module: automationModules.BILLING,
    },
    { label: 'Payment Refunded', code: 'TRIG_PAYMENT_REFUND', ruleValidationCode: 'PAYMENT_REFUND', module: automationModules.BILLING },
    {
      label: 'Payment Past Due',
      code: 'TRIG_PAYMENT_REQUEST_PASTDUE',
      ruleValidationCode: 'TRIG_PAYMENT_REQUEST_PASTDUE',
      module: automationModules.BILLING,
    },
    {
      label: 'Invoice Past Due',
      code: 'TRIG_INVOICE_PASTDUE',
      ruleValidationCode: 'TRIG_INVOICE_PASTDUE',
      module: automationModules.BILLING,
    },
  ],
};

const caseTriggerAction = {
  label: 'Cases',
  items: [
    { label: 'Case Created', code: 'TRIG_CASE_DATA_ENTRY', ruleValidationCode: 'CASE_DATA_ENTRY', module: automationModules.CASES },
    { label: 'Case Closed', code: 'TRIG_CASE_STATUS_CHANGE', ruleValidationCode: 'CASE_STATUS_CHANGE', module: automationModules.CASES },
    {
      label: 'Case Stage Changed',
      code: 'TRIG_CASE_STAGE_CHANGE',
      ruleValidationCode: 'CASE_STAGE_CHANGE',
      module: automationModules.CASES,
    },
    {
      label: 'Review Request Sent',
      code: 'TRIG_REVIEW_REQUEST',
      ruleValidationCode: 'TRIG_REVIEW_REQUEST',
      module: automationModules.CASES,
    },
  ],
};

const filesTriggerAction = {
  label: 'Files',
  items: [
    {
      label: 'New File Created',
      code: 'TRIG_FILE_CREATE',
      ruleValidationCode: 'FILE_CREATE',
      module: automationModules.FILES,
    },
    {
      label: 'E-Signature Status Changed',
      code: 'TRIG_ESIGN_STATUS_CHANGE',
      ruleValidationCode: 'ESIGN_STATUS_CHANGE',
      module: automationModules.FILES,
    },
    {
      label: 'New File Uploaded',
      code: 'TRIG_FILE_UPLOAD',
      ruleValidationCode: 'FILE_UPLOAD',
      module: automationModules.FILES,
    },
  ],
};

const contactTriggerAction = {
  label: 'Contacts',
  items: [
    { label: 'New Contact Created', code: 'TRIG_CONTACT_CREATE', ruleValidationCode: 'CONTACT_CREATE', module: automationModules.CONTACTS },
  ],
};

const leadsTriggerAction = {
  label: 'Leads',
  items: [
    { label: 'Lead Created', code: 'TRIG_LEAD_CREATE', ruleValidationCode: 'LEAD_CREATE', module: automationModules.LEADS },
    {
      label: 'Lead Status Changed',
      code: 'TRIG_LEAD_STATUS_CHANGE',
      ruleValidationCode: 'LEAD_STATUS_CHANGE',
      module: automationModules.LEADS,
    },
    {
      label: 'Lead Stage Changed',
      code: 'TRIG_LEAD_STAGE_CHANGE',
      ruleValidationCode: 'LEAD_STAGE_CHANGE',
      module: automationModules.LEADS,
    },
    {
      label: 'Lead Converted To Case',
      code: 'TRIG_LEAD_CONV_CASE',
      ruleValidationCode: 'LEAD_CONV_CASE',
      module: automationModules.LEADS,
    },
  ],
};

export const groupedTriggers = [
  eventTriggerAction,
  taskTriggerAction,
  billingTriggerAction,
  caseTriggerAction,
  filesTriggerAction,
  contactTriggerAction,
  leadsTriggerAction,
];

// ===========================  Filter Options =================================== //
export const BY_PRACTICE_AREA = 'By Practice Area';
export const BY_VENUE = 'By Venue';
export const BY_POSITION = 'By Position';
export const VIEWED_UNVIEWED = 'By Viewed/ Unviewed';

//Event Filter Options Labels
export const BY_EVENT_GUESTS = 'By Event Guests';
export const BY_TASK_ASSIGNEE = 'By Task Assignee';
export const BY_EVENT_LOCATION = 'By Event Location';
export const BY_EVENT_TYPE = 'By Event Type';

// Task Filter Options Labels
export const BY_TASK_PRIORITY = 'By Task Priority';
export const BY_TASK_DUE_DATE = 'By Task Due Date';

// Case Filter Options Labels
export const BY_CASE_MATTER = 'By Case Matter';
export const BY_CASE_CLOSURE_REASON = 'By Case Closure Reason';
export const BY_CASE_OUTCOME = 'By Case Outcome';

//Lead Filter Options Labels
export const BY_LEAD_STAGE = 'By Lead Stage';
export const BY_CASE_STAGE = 'By Case Stage';
export const BY_POTENTIAL_CASE_VALUE = 'By Potential Case Value';
export const BY_TAG = 'By Global Tag';
export const BY_LEAD_PRIORITY = 'By Lead Priority';

export const dueDateDropdownList = [
  { label: 'Day (s)', value: 'Day (s)' },
  { label: 'Week (s)', value: 'Week (s)' },
  { label: 'Month (s)', value: 'Month (s)' },
];

export const commonFilterOptions = [
  { label: BY_PRACTICE_AREA, value: BY_PRACTICE_AREA },
  { label: BY_CASE_MATTER, value: BY_CASE_MATTER },
  { label: BY_VENUE, value: BY_VENUE },
  { label: BY_POSITION, value: BY_POSITION },
];

export const eventFilterOptions = [
  { label: BY_EVENT_GUESTS, value: BY_EVENT_GUESTS },
  { label: BY_EVENT_LOCATION, value: BY_EVENT_LOCATION },
  { label: BY_EVENT_TYPE, value: BY_EVENT_TYPE },
  { label: BY_PRACTICE_AREA, value: BY_PRACTICE_AREA },
  { label: BY_VENUE, value: BY_VENUE },
  { label: BY_CASE_MATTER, value: BY_CASE_MATTER },
  { label: BY_POSITION, value: BY_POSITION },
];
export const taskFilterOptions = [
  { label: BY_TASK_ASSIGNEE, value: BY_EVENT_GUESTS },
  { label: BY_TASK_PRIORITY, value: BY_TASK_PRIORITY },
  { label: BY_TASK_DUE_DATE, value: BY_TASK_DUE_DATE },
  { label: BY_PRACTICE_AREA, value: BY_PRACTICE_AREA },
  { label: BY_VENUE, value: BY_VENUE },
  { label: BY_CASE_MATTER, value: BY_CASE_MATTER },
  { label: BY_POSITION, value: BY_POSITION },
];
export const billingFilterOptions = [
  { label: BY_PRACTICE_AREA, value: BY_PRACTICE_AREA },
  { label: BY_VENUE, value: BY_VENUE },
  { label: BY_CASE_MATTER, value: BY_CASE_MATTER },
  { label: BY_POSITION, value: BY_POSITION },
];

export const pastDueFilterOptions = [...billingFilterOptions, { label: VIEWED_UNVIEWED, value: VIEWED_UNVIEWED }];

export const caseFilterOptions = [...commonFilterOptions];

export const caseClosedFilterOptions = [
  { label: BY_CASE_CLOSURE_REASON, value: BY_CASE_CLOSURE_REASON },
  { label: BY_CASE_OUTCOME, value: BY_CASE_OUTCOME },
  { label: BY_POSITION, value: BY_POSITION },
];
export const fileFilterOptions = [...commonFilterOptions];
export const contactFilterOptions = [...commonFilterOptions];

export const leadFilterOptions = [
  ...commonFilterOptions,
  { label: BY_POTENTIAL_CASE_VALUE, value: BY_POTENTIAL_CASE_VALUE },
  { label: BY_TAG, value: BY_TAG },
  { label: BY_LEAD_PRIORITY, value: BY_LEAD_PRIORITY },
];

export const leadStageFilter = { label: BY_LEAD_STAGE, value: BY_LEAD_STAGE };
export const caseStageFilter = { label: BY_CASE_STAGE, value: BY_CASE_STAGE };

// ===========================  Filter condition Options =================================== //
export const isOrNotConditionOptions = [
  { label: 'is not', value: 'ne' },
  { label: 'is', value: 'eq' },
];

export const viewedUnviewedOptions = [
  { label: 'Viewed', value: true },
  { label: 'Not Viewed', value: false },
];

export const includesConditionOptions = [{ label: 'includes', value: 'contains' }];

export const dueDateConditionOptions = [
  { label: 'is not', value: 'ne' },
  { label: 'is', value: 'eq' },
  { label: 'before', value: 'lt' },
  { label: 'after', value: 'gt' },
  { label: 'on or before', value: 'lte' },
  { label: 'on or after', value: 'gte' },
];

export const isGreaterThanOptions = [{ label: 'is greater than', value: 'gt' }];

export const priorityOptions = [
  { label: 'No Priority', value: 'No Priority' },
  {
    label: 'Low',
    value: 'Low',
  },
  { label: 'Medium', value: 'Medium' },
  { label: 'High', value: 'High' },
];

export const reminderCustomOptions = [
  { label: 'Minute (s)', value: 'minutes' },
  { label: 'Hour (s)', value: 'hours' },
  { label: 'Day (s)', value: 'days' },
  { label: 'Week (s)', value: 'weeks' },
];

export const delayCardOptions = [...reminderCustomOptions, { label: 'Month (s)', value: 'months' }, { label: 'Year (s)', value: 'years' }];

export const generalContactListOptions = [
  {
    label: 'Primary Contact',
    value: 'primary_contact',
  },
  {
    label: 'Billing Contact',
    value: 'billing_contact',
  },
];

export const generalLeadContactListLead = [
  {
    label: 'Client',
    value: 'primary_contact',
  },
  {
    label: 'On behalf of',
    value: 'billing_contact',
  },
];

export const templateFormatOptions = [
  { value: 'pdf', label: 'PDF' },
  { value: 'docx', label: 'DOCX' },
];

export const paymentDaysPastDue = [
  { label: '1 Day', value: '1#days' },
  { label: '15 Days', value: '15#days' },
  { label: '30 Days', value: '30#days' },
  { label: '60 Days', value: '60#days' },
  { label: '90 Days', value: '90#days' },
];

export const invoiceDaysPastDue = [
  { label: '30 Days', value: '30#days' },
  { label: '60 Days', value: '60#days' },
  { label: '90 Days', value: '90#days' },
];

export const generalCategoryContactListLead = [
  {
    label: 'Client',
    value: 'primary_contact',
  },
  {
    label: 'On behalf of',
    value: 'billing_contact',
  },
];

export const leadPositionFilter = [
  {
    label: 'Client',
    value: 'client',
  },
  {
    label: 'On behalf of',
    value: 'on_behalf',
  },
];

export const teamMemberRolesList = [
  { label: 'Lead Attorney', value: 'lead_attorney', code: 'TEAM_MEMBER_ROLE' },
  { label: 'Lead Associate', value: 'lead_associate', code: 'TEAM_MEMBER_ROLE' },
  { label: 'Lead Paralegal', value: 'lead_paralegal', code: 'TEAM_MEMBER_ROLE' },
  { label: 'Lead Case Manager', value: 'lead_case_manager', code: 'TEAM_MEMBER_ROLE' },
];

export const teamMemberLeadAssignee = [{ label: 'Lead Assignee', value: 'assigned_lead_user', code: 'TEAM_MEMBER_ROLE' }];

export const generalCategoryContactList = [
  {
    label: 'Primary Contact',
    value: 'primary_contact',
  },
  {
    label: 'Billing Contact',
    value: 'billing_contact',
  },
];
export const actionCodes = {
  ACT_SHARE_FORM: 'ACT_SHARE_FORM',
  ACT_SEND_SECURE_MESSAGE: 'ACT_SEND_SECURE_MESSAGE',
  ACT_TASK_CREATE: 'ACT_TASK_CREATE',
  ACT_SEND_TEXT_MESSAGE: 'ACT_SEND_TEXT_MESSAGE',
  ACT_CREATE_DOCUMENT: 'ACT_CREATE_DOCUMENT',
  ACT_BULK_UPLOAD_FOLDER: 'ACT_BULK_UPLOAD_FOLDER',
  ACT_EVENT_CREATE: 'ACT_EVENT_CREATE',
  ACT_SEND_EMAIL: 'ACT_SEND_EMAIL',
};

export const actionLabels = {
  ACT_SHARE_FORM: 'Share Form',
  ACT_SEND_SECURE_MESSAGE: 'Create Message',
  ACT_TASK_CREATE: 'Add Task',
  ACT_SEND_TEXT_MESSAGE: 'Text Message',
  ACT_CREATE_DOCUMENT: 'Create Document',
  ACT_BULK_UPLOAD_FOLDER: 'Folder Structure',
  ACT_EVENT_CREATE: 'Create Event',
  ACT_SEND_EMAIL: 'Send Email',
};

export const actionOptions = [
  {
    label: 'Events',
    items: [{ label: actionLabels.ACT_EVENT_CREATE, value: actionCodes.ACT_EVENT_CREATE }],
  },
  {
    label: 'Tasks',
    items: [{ label: actionLabels.ACT_TASK_CREATE, value: actionCodes.ACT_TASK_CREATE }],
  },
  {
    label: 'Messages & Notifications',
    items: [
      { label: actionLabels.ACT_SEND_SECURE_MESSAGE, value: actionCodes.ACT_SEND_SECURE_MESSAGE },
      { label: actionLabels.ACT_SEND_TEXT_MESSAGE, value: actionCodes.ACT_SEND_TEXT_MESSAGE },
      { label: actionLabels.ACT_SEND_EMAIL, value: actionCodes.ACT_SEND_EMAIL },
    ],
  },
  {
    label: 'Files',
    items: [
      { label: actionLabels.ACT_CREATE_DOCUMENT, value: actionCodes.ACT_CREATE_DOCUMENT },
      { label: actionLabels.ACT_BULK_UPLOAD_FOLDER, value: actionCodes.ACT_BULK_UPLOAD_FOLDER },
    ],
  },
  {
    label: 'Forms',
    items: [{ label: actionLabels.ACT_SHARE_FORM, value: actionCodes.ACT_SHARE_FORM }],
  },
];

//All trigger with corresponding actions
export const filterMap = {
  TRIG_EVENT_CREATE: [
    actionCodes.ACT_TASK_CREATE,
    actionCodes.ACT_CREATE_DOCUMENT,
    actionCodes.ACT_SHARE_FORM,
    actionCodes.ACT_SEND_SECURE_MESSAGE,
    actionCodes.ACT_SEND_TEXT_MESSAGE,
    actionCodes.ACT_EVENT_CREATE,
    actionCodes.ACT_SEND_EMAIL,
  ],
  TRIG_EVENT_CANCEL: [
    actionCodes.ACT_TASK_CREATE,
    actionCodes.ACT_CREATE_DOCUMENT,
    actionCodes.ACT_SEND_SECURE_MESSAGE,
    actionCodes.ACT_SEND_TEXT_MESSAGE,
    actionCodes.ACT_SEND_EMAIL,
  ],
  TRIG_EVENT_DATE_TIME_CHANGED: [
    actionCodes.ACT_TASK_CREATE,
    actionCodes.ACT_CREATE_DOCUMENT,
    actionCodes.ACT_SEND_SECURE_MESSAGE,
    actionCodes.ACT_SEND_TEXT_MESSAGE,
    actionCodes.ACT_SEND_EMAIL,
  ],
  TRIG_TASK_CREATE: [
    actionCodes.ACT_EVENT_CREATE,
    actionCodes.ACT_SHARE_FORM,
    actionCodes.ACT_SEND_SECURE_MESSAGE,
    actionCodes.ACT_SEND_TEXT_MESSAGE,
  ],
  TRIG_TASK_STATUS_CHANGE: [actionCodes.ACT_EVENT_CREATE, actionCodes.ACT_SEND_SECURE_MESSAGE, actionCodes.ACT_SEND_TEXT_MESSAGE],
  TRIG_PAYMENT_RECEIVE: [
    actionCodes.ACT_EVENT_CREATE,
    actionCodes.ACT_TASK_CREATE,
    actionCodes.ACT_SEND_SECURE_MESSAGE,
    actionCodes.ACT_SEND_TEXT_MESSAGE,
  ],
  TRIG_PAYMENT_REFUND: [
    actionCodes.ACT_EVENT_CREATE,
    actionCodes.ACT_TASK_CREATE,
    actionCodes.ACT_SEND_SECURE_MESSAGE,
    actionCodes.ACT_SEND_TEXT_MESSAGE,
    actionCodes.ACT_SEND_EMAIL,
  ],
  TRIG_PAYMENT_REQUEST_PASTDUE: [
    actionCodes.ACT_TASK_CREATE,
    actionCodes.ACT_CREATE_DOCUMENT,
    actionCodes.ACT_SEND_SECURE_MESSAGE,
    actionCodes.ACT_SEND_TEXT_MESSAGE,
    actionCodes.ACT_SEND_EMAIL,
  ],
  TRIG_INVOICE_PASTDUE: [
    actionCodes.ACT_TASK_CREATE,
    actionCodes.ACT_CREATE_DOCUMENT,
    actionCodes.ACT_SEND_SECURE_MESSAGE,
    actionCodes.ACT_SEND_TEXT_MESSAGE,
    actionCodes.ACT_SEND_EMAIL,
  ],
  TRIG_CASE_DATA_ENTRY: [
    actionCodes.ACT_EVENT_CREATE,
    actionCodes.ACT_TASK_CREATE,
    actionCodes.ACT_BULK_UPLOAD_FOLDER,
    actionCodes.ACT_CREATE_DOCUMENT,
    actionCodes.ACT_SHARE_FORM,
    actionCodes.ACT_SEND_SECURE_MESSAGE,
    actionCodes.ACT_SEND_TEXT_MESSAGE,
    actionCodes.ACT_SEND_EMAIL,
  ],
  TRIG_CASE_STATUS_CHANGE: [
    actionCodes.ACT_EVENT_CREATE,
    actionCodes.ACT_TASK_CREATE,
    actionCodes.ACT_BULK_UPLOAD_FOLDER,
    actionCodes.ACT_CREATE_DOCUMENT,
    actionCodes.ACT_SEND_SECURE_MESSAGE,
    actionCodes.ACT_SEND_TEXT_MESSAGE,
    actionCodes.ACT_SEND_EMAIL,
  ],
  TRIG_CASE_STAGE_CHANGE: [
    actionCodes.ACT_EVENT_CREATE,
    actionCodes.ACT_TASK_CREATE,
    actionCodes.ACT_BULK_UPLOAD_FOLDER,
    actionCodes.ACT_CREATE_DOCUMENT,
    actionCodes.ACT_SHARE_FORM,
    actionCodes.ACT_SEND_SECURE_MESSAGE,
    actionCodes.ACT_SEND_TEXT_MESSAGE,
    actionCodes.ACT_SEND_EMAIL,
  ],
  TRIG_REVIEW_REQUEST: [
    actionCodes.ACT_SHARE_FORM,
    actionCodes.ACT_SEND_SECURE_MESSAGE,
    actionCodes.ACT_SEND_TEXT_MESSAGE,
    actionCodes.ACT_SEND_EMAIL,
  ],
  TRIG_FILE_CREATE: [
    actionCodes.ACT_EVENT_CREATE,
    actionCodes.ACT_TASK_CREATE,
    actionCodes.ACT_SEND_SECURE_MESSAGE,
    actionCodes.ACT_SEND_TEXT_MESSAGE,
  ],
  TRIG_ESIGN_STATUS_CHANGE: [
    actionCodes.ACT_EVENT_CREATE,
    actionCodes.ACT_TASK_CREATE,
    actionCodes.ACT_SHARE_FORM,
    actionCodes.ACT_SEND_SECURE_MESSAGE,
    actionCodes.ACT_SEND_TEXT_MESSAGE,
  ],
  TRIG_FILE_UPLOAD: [
    actionCodes.ACT_EVENT_CREATE,
    actionCodes.ACT_TASK_CREATE,
    actionCodes.ACT_SEND_SECURE_MESSAGE,
    actionCodes.ACT_SEND_TEXT_MESSAGE,
  ],
  TRIG_CONTACT_CREATE: [
    actionCodes.ACT_EVENT_CREATE,
    actionCodes.ACT_TASK_CREATE,
    actionCodes.ACT_SEND_SECURE_MESSAGE,
    actionCodes.ACT_SEND_TEXT_MESSAGE,
  ],
  TRIG_LEAD_CREATE: [
    actionCodes.ACT_EVENT_CREATE,
    actionCodes.ACT_TASK_CREATE,
    actionCodes.ACT_BULK_UPLOAD_FOLDER,
    actionCodes.ACT_CREATE_DOCUMENT,
    actionCodes.ACT_SHARE_FORM,
    actionCodes.ACT_SEND_SECURE_MESSAGE,
    actionCodes.ACT_SEND_TEXT_MESSAGE,
    actionCodes.ACT_SEND_EMAIL,
  ],
  TRIG_LEAD_STATUS_CHANGE: [
    actionCodes.ACT_EVENT_CREATE,
    actionCodes.ACT_TASK_CREATE,
    actionCodes.ACT_BULK_UPLOAD_FOLDER,
    actionCodes.ACT_CREATE_DOCUMENT,
    actionCodes.ACT_SHARE_FORM,
    actionCodes.ACT_SEND_SECURE_MESSAGE,
    actionCodes.ACT_SEND_TEXT_MESSAGE,
  ],
  TRIG_LEAD_STAGE_CHANGE: [
    actionCodes.ACT_EVENT_CREATE,
    actionCodes.ACT_TASK_CREATE,
    actionCodes.ACT_BULK_UPLOAD_FOLDER,
    actionCodes.ACT_CREATE_DOCUMENT,
    actionCodes.ACT_SHARE_FORM,
    actionCodes.ACT_SEND_SECURE_MESSAGE,
    actionCodes.ACT_SEND_TEXT_MESSAGE,
    actionCodes.ACT_SEND_EMAIL,
  ],
  TRIG_LEAD_CONV_CASE: [
    actionCodes.ACT_EVENT_CREATE,
    actionCodes.ACT_TASK_CREATE,
    actionCodes.ACT_BULK_UPLOAD_FOLDER,
    actionCodes.ACT_CREATE_DOCUMENT,
    actionCodes.ACT_SHARE_FORM,
    actionCodes.ACT_SEND_SECURE_MESSAGE,
    actionCodes.ACT_SEND_TEXT_MESSAGE,
    actionCodes.ACT_SEND_EMAIL,
  ],
};

export const defaultKeys = {
  form: '',
  action_code: '',
  delay: '',
  contact_assignees: [],
  message_body: '',
  attachments: [],
  timeTracker: '',
  creator_firm_user_id: '',
  selectedMessageTo: [],
  subject: '',
  message: '',
  folderStructure: [],
  template: '',
  document_name: '',
  document_format: '',
  send_mail: false,
  title: '',
  meeting_url: '',
  meeting_cycle: '',
  meeting_due_date_period: '',
  event_type: '',
  location: '',
  description: '',
  reminders: [],
  task_name: '',
  priority: '',
  assignTo: [],
  subTask: [],
  due_date_cycle: '',
  event_preference: 'event_before_schedule_date',
};

export const eventConfigOptions = [
  { name: 'Before', value: 'event_before_schedule_date' },
  { name: 'After', value: 'event_after_schedule_date' },
];

export const contactRoles = ['primary_contact', 'billing_contact', 'client', 'on_behalf'];
